import React from 'react';
import { Paper, Typography } from '@mui/material';

const CommandTile = ({ 
    icon: Icon, 
    title, 
    bgcolor, 
    hoverColor, 
    onClick,
    sx = {}
}) => {
    return (
        <Paper 
            elevation={6}
            sx={{ 
                p: 2, // Reduced padding
                cursor: 'pointer',
                width: { xs: '300px', md: '350px' },
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: 4,
                bgcolor: bgcolor,
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                '&:hover': { 
                    transform: 'scale(1.02) translateY(-5px)', // Subtle lift
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                    bgcolor: hoverColor
                },
                '&:active': {
                    transform: 'scale(0.98)'
                },
                ...sx
            }}
            onClick={onClick}
        >
            <Icon sx={{ fontSize: { xs: 60, md: 80 }, color: 'white', mb: 2 }} />
            <Typography 
                variant="h2" 
                fontWeight="900" 
                sx={{ 
                    color: 'white',
                    fontSize: { xs: '1.5rem', md: '1.8rem' },
                    textAlign: 'center',
                    lineHeight: 1.1,
                    px: 1
                }}
            >
                {title}
            </Typography>
        </Paper>
    );
};

export default CommandTile;
